<template>
  <component :is="metaComponent" v-bind="$props" />
</template>

<script>
import SearchDistrictMetadata from './searchDistrictMetaData'
import SearchEmploymentOrJobTypeMetadata from './searchEmploymentOrJobTypeMetaData'

export default {
  components: {
    'meta-search-district': SearchDistrictMetadata,
    'meta-search-employment-job': SearchEmploymentOrJobTypeMetadata,
  },
  computed: {
    hasDistrict() {
      return Array.isArray(this.filterQueryObject.district) && this.filterQueryObject.district.length > 0
    },

    hasEmployment() {
      return Array.isArray(this.filterQueryObject.employment) && this.filterQueryObject.employment.length > 0
    },

    hasJobType() {
      return Array.isArray(this.filterQueryObject.jobType) && this.filterQueryObject.jobType.length > 0
    },

    metaComponent() {
      if (this.hasEmployment || this.hasJobType) {
        return 'meta-search-employment-job'
      } else if (this.hasDistrict) {
        return 'meta-search-district'
      }
      return ''
    },
  },
  props: {
    filterQueryObject: {
      default: () => ({}),
      type: Object,
    },
    paramTimestamp: {
      default: 0,
      type: Number,
    },
    /**
     * Total number of jobs matching search param
     */
    paramTotal: {
      default: 0,
      type: Number,
    },
  },
}
</script>
